import { connect } from 'react-redux';
import { Route, Switch } from 'react-router';
import { Spin } from 'antd';
import { AppState } from '../../reducers';
import TransferList from './TransferList';

function Transfer({ loading }: any) {
  return (
    <Spin spinning={loading}>
      <Switch>
        <Route exact path="/transfer/list" component={TransferList} />
      </Switch>
    </Spin>
  );
}

const mapStateToProps = (state: AppState) => ({
  loading: state.transfer.loading,
});

export default connect(mapStateToProps)(Transfer);
